import { render } from "./Amplitude.vue?vue&type=template&id=b2211e02"
import script from "./Amplitude.vue?vue&type=script&lang=js"
export * from "./Amplitude.vue?vue&type=script&lang=js"

import "./Amplitude.vue?vue&type=style&index=0&id=b2211e02&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__